module.exports = __webpack_public_path__ + "img/btn_start.edbd1ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/btn_start.png
// module id = ./assets/images/btn_start.png
// module chunks = 4